const SECONDS_IN_A_DAY = 86400;

const yearlySavingsPrediction = 3_080_000; // kg
const savingsPerSecond = yearlySavingsPrediction / 365 / SECONDS_IN_A_DAY; // 0.097

const defaultStartDate = new Date("2021-09-14").getTime();

const formatter = new Intl.NumberFormat("en-GB", {
  minimumFractionDigits: 4,
});

const computeCarbonSavings = (startDate: number): number => {
  const todayDate = new Date().getTime();
  const timeDiff = (todayDate - startDate) / 1000;
  const savings = (timeDiff * savingsPerSecond) / 1000;

  return savings;
};

const updateCarbonSavings = (target: HTMLElement): void => {
  const startDate = target.dataset.startdate
    ? new Date(target.dataset.startdate).getTime()
    : defaultStartDate;

  const savings = computeCarbonSavings(new Date(startDate).getTime());
  const savingsFormatted = formatter.format(savings);

  target.innerHTML = savingsFormatted
    .split("")
    .map((char) => {
      const digitClass = char === "." || char === "," ? "symbol" : "number";

      return `<span class="${digitClass}">${char}</span>`;
    })
    .join("");
};

export { computeCarbonSavings, updateCarbonSavings };
